/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const ANONYMOUS_ID = -999;
export const ANONYMOUS_GUID = "ffffffff-ffff-ffff-ffff-ffffffffffff";
